import React from 'react';

import { ConsentCompletedContainer, Explanation } from './ConsentsCompleted.styled';
import ConsentsCompletedIcon from 'assets/icons/consents-complete.svg?react';

export const ConsentsCompleted = () => (
  <ConsentCompletedContainer>
    <ConsentsCompletedIcon />
    <Explanation>All of your consents are signed!</Explanation>
    <Explanation>Thank you!</Explanation>
  </ConsentCompletedContainer>
);
